<template>
  <div class="card mt-50 mb-50">
    <div class="card-title mx-auto">Manual Payment</div>
    <LoadingPage v-if="isLoading" />
    <form
      id="contactForm"
      class="container"
      @submit.prevent="submitForm"
      v-if="!isLoading"
    >
      <div class="row row-1 pb-3 mb-5">
        <div class="col-12 text-center mb-3">
          <img src="@/assets/img/BNI.png" alt="logo-bni" class="image-bni" />
          <div class="d-flex flex-column items-center justify-content-center">
            <div class="text-md font-bold">BNI Dollar USD</div>
            <div class="text-md font-bold">PT TEKNOLOGI LAUTAN NUSANTARA</div>
          </div>
        </div>
        <div class="col-6 d-flex flex-column justify-content-center align-items-center">
          <div>Number</div>
          <div>1851703814</div>
        </div>
        <div class="col-6 d-flex flex-column justify-content-center align-items-center">
          <div>Swift Code</div>
          <div>BNINIDJAXXX</div>
        </div>
        <div
          class="col-12 d-flex flex-column justify-content-center align-items-center mt-3"
        >
          <div>Total Payment : USD ${{ detailOrder?.trx?.total_amount }}</div>
        </div>
      </div>
      <span id="card-header">Payment Confirmation</span>
      <div class="row mt-2">
        <div class="col-12 col-lg-12 col-md-12">
          <div>Bank Name</div>
          <div class="form-group">
            <input
              type="text"
              name="buyer_bank_name"
              v-model="buyerBankName"
              class="form-control"
              id="buyer_bank_name"
              required
              placeholder="Buyer Bank Name"
            />
          </div>
        </div>
        <div class="col-12 col-lg-12 col-md-12">
          <div>Bank Account Number</div>
          <div class="form-group">
            <input
              type="text"
              name="buyer_bank_account_number"
              v-model="buyerBankNumber"
              class="form-control"
              id="buyer_bank_account_number"
              required
              placeholder="Buyer Bank Account Number"
            />
          </div>
        </div>
        <div class="col-12 col-lg-12 col-md-12">
          <div>Bank Account Holder</div>
          <div class="form-group">
            <input
              type="text"
              name="buyer_bank_account_holder"
              v-model="buyerBankAccountHolder"
              class="form-control"
              id="buyer_bank_account_holder"
              required
              placeholder="Buyer Bank Account Holder"
            />
          </div>
        </div>
        <div class="col-12 col-lg-12 col-md-12">
          <div>Transfer Receipt</div>
          <div class="form-group">
            <upload-file
              v-model="buyerTransferReceipt"
              label="Upload Transfer Receipt"
              @imageSelected="handleImageSelected"
            />
          </div>
        </div>
        <div class="col-12 col-lg-12 col-md-12">
          <button class="btn btn-md btn-primary text-center mx-auto w-100">
            <b>Confirm Payment</b>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script setup>
import UploadFile from "@/components/Contact/UploadFile.vue";
import LoadingPage from "../Common/LoadingPage.vue";
import axios, { all } from "axios";
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";

const buyerTransferReceipt = ref("");
const isLoading = ref(false);
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
const buyerBankName = ref();
const buyerBankNumber = ref();
const buyerBankAccountHolder = ref();
const orderCode = ref();
const route = useRoute();
const detailOrder = ref({});

orderCode.value = route.params.orderCode;

const loadDetailOrder = async () => {
  axios({
    method: "get",
    url: apiBaseUrl + "order/detail?order_code=" + orderCode.value,
  })
    .then((response) => {
      detailOrder.value = response.data.data;
    })
    .catch((error) => {
      isLoading.value = false;
      Swal.fire({
        title: "Error",
        text: Array.isArray(error.response.data.message)
          ? error.response.data.message.join(", ")
          : error.response.data.message,
        icon: "warning",
      });
    });
};

loadDetailOrder();

const handleImageSelected = (base64) => {
  buyerTransferReceipt.value = base64;
};

const submitForm = async () => {
  isLoading.value = true;

  axios({
    method: "post",
    url: apiBaseUrl + "order/upload-transfer-receipt",
    data: {
      order_code: orderCode.value,
      buyer_bank_name: buyerBankName.value,
      buyer_bank_account_number: buyerBankNumber.value,
      buyer_bank_account_holder: buyerBankAccountHolder.value,
      buyer_transfer_receipt: buyerTransferReceipt.value,
    },
  })
    .then((response) => {
      setTimeout(() => {
        window.location.href = "/payment/pending";
      }, 1500);
    })
    .catch((error) => {
      isLoading.value = false;
      Swal.fire({
        title: "Error",
        text: Array.isArray(error.response.data.message)
          ? error.response.data.message.join(", ")
          : error.response.data.message,
        icon: "warning",
      });
    });
};
</script>
<style scoped>
.image-bni {
  width: 170px;
  margin-top: 20px;
  margin-bottom: 20px;
}
body {
  background: #ddd;
  min-height: 100vh;
  vertical-align: middle;
  display: flex;
}
.card {
  margin: auto;
  width: 800px;
  padding: 3rem 3.5rem;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

@media (max-width: 767px) {
  .card {
    width: 90%;
    padding: 1.5rem;
  }
}
@media (height: 1366px) {
  .card {
    width: 90%;
    padding: 8vh;
  }
}
.card-title {
  font-weight: 700;
  font-size: 2.5em;
}
.nav {
  display: flex;
}
.nav ul {
  list-style-type: none;
  display: flex;
  padding-inline-start: unset;
  margin-bottom: 6vh;
}
.nav li {
  padding: 1rem;
}
.nav li a {
  color: black;
  text-decoration: none;
}
.active {
  border-bottom: 2px solid black;
  font-weight: bold;
}

input {
  border: none;
  outline: none;
  font-size: 1rem;
  font-weight: 600;
  color: #000;
  width: 100%;
  min-width: unset;
  background-color: transparent;
  border-color: transparent;
  margin: 0;
}
form a {
  color: grey;
  text-decoration: none;
  font-size: 0.87rem;
  font-weight: bold;
}
form a:hover {
  color: grey;
  text-decoration: none;
}
form .row {
  margin: 0;
  overflow: hidden;
}
form .row-1 {
  border: 1px solid rgba(0, 0, 0, 0.137);
  padding: 0.5rem;
  outline: none;
  width: 100%;
  min-width: unset;
  border-radius: 5px;
  background-color: rgba(221, 228, 236, 0.301);
  border-color: rgba(221, 228, 236, 0.459);
  margin: 2vh 0;
  overflow: hidden;
}
form .row-2 {
  border: none;
  outline: none;
  background-color: transparent;
  margin: 0;
  padding: 0 0.8rem;
}
form .row .row-2 {
  border: none;
  outline: none;
  background-color: transparent;
  margin: 0;
  padding: 0 0.8rem;
}
form .row .col-2,
.col-7,
.col-3 {
  display: flex;
  align-items: center;
  text-align: center;
  padding: 0 1vh;
}
form .row .col-2 {
  padding-right: 0;
}

#card-header {
  font-weight: bold;
  font-size: 1.5rem;
}
#card-inner {
  font-size: 0.7rem;
  color: gray;
}
.three .col-7 {
  padding-left: 0;
}
.three {
  overflow: hidden;
  justify-content: space-between;
}
.three .col-2 {
  border: 1px solid rgba(0, 0, 0, 0.137);
  padding: 0.5rem;
  outline: none;
  width: 100%;
  min-width: unset;
  border-radius: 5px;
  background-color: rgba(221, 228, 236, 0.301);
  border-color: rgba(221, 228, 236, 0.459);
  margin: 2vh 0;
  width: fit-content;
  overflow: hidden;
}
.three .col-2 input {
  font-size: 0.7rem;
  margin-left: 1vh;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
input:focus:-moz-placeholder {
  color: transparent;
}
input:focus::-moz-placeholder {
  color: transparent;
}
input:focus:-ms-input-placeholder {
  color: transparent;
}
</style>
